import { useNavigate, useParams } from "react-router-dom";
import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { LittleSubHeadline, MediumText, NotificationText, SubTitle } from "../../../../components/typography";
import { FixedBodyDiv, TitleSpan } from "../team/view-team";
import { useStructureStore } from "../../../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../../../assets/utils/enums/basket";
import { StructureItem, StructureItems, StructureSection } from "./main";
import { useMemo, useState } from "react";
import { motion } from 'framer-motion';
import chevronIcon from '../../../../assets/images/icons/arrow-down-icon.svg'
import plusIcon from '../../../../assets/images/icons/plus-dark-icon.svg';

export default function ObjectStructureTab() {
    const { id } = useParams();
    const [isOpen, setIsOpen] = useState<boolean>(true);
    const [isOpenOther, setIsOpenOther] = useState<boolean>(true);
    const navigate = useNavigate();
    const structure = useStructureStore(
        (s) => s.structures[id as ObjectsEnum]
    );
    const visibleFields = useMemo(
        () => structure.fields.general.filter((f) => f.visible),
        [structure.fields.general]
    );

    const hiddenFields = useMemo(
        () => structure.fields.general.filter((f) => !f.visible),
        [structure.fields.general]
    );

    return (
        <FixedBodyDiv
            className={`w-60 ${SETTINGS_BODY_DIV} gap-3`}
            $isPadding={true}
        >
            <TitleSpan className="pb-0">
                <MediumText>Редагувати папки</MediumText>
                <NotificationText>Налаштування полів вплине на структуру всіх записів у таблицях та папці. Ви можете організувати поля в групи і згорнути ті, які ви рідко використовуєте в структурі запису. Для отримання додаткової інформації щодо конструктора полів (папок), перейдіть до нашого <b className="fw-normal accent-text">Посібника Користувача.</b></NotificationText>
                <NotificationText className="accent-text">Дізнатися більше</NotificationText>
            </TitleSpan>
            <StructureSection className="gap-0">
                <TitleSpan className="pb-2 flex-row gap-2 align-items-center">
                    <img src={structure.entityIcon} alt={structure.entityTitle} />
                    <SubTitle>{structure.entityTitle}</SubTitle>
                </TitleSpan>
                <StructureItems>
                    <StructureItem onClick={() => setIsOpen((v) => !v)}
                        style={{ cursor: 'pointer', borderRadius: !isOpen ? "8px" : "" }}>
                        {/* <img src={item.icon} alt={item.key} /> */}
                        <MediumText>Загальна інформація</MediumText>
                        <img src={chevronIcon} alt="chevron-icon"
                            style={{
                                marginLeft: 'auto',
                                transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                                transition: 'transform 0.2s ease',
                            }}
                        />
                    </StructureItem>
                    <motion.div
                        initial={false}
                        className="structure-group"
                        animate={{
                            height: isOpen ? 'auto' : 0,
                            opacity: isOpen ? 1 : 0,
                        }}
                        transition={{
                            type: 'spring',
                            stiffness: 110,
                            damping: 22,
                        }}
                        style={{ overflow: 'hidden', scrollBehavior: 'smooth' }}
                    >{visibleFields.map((item) =>
                        <StructureItem key={item.key} className="" onClick={() => navigate(`/settings/structure/${structure.entity}/update`, {
                            state: item,
                        })}>
                            <img src={item.icon} alt={item.key} />
                            <LittleSubHeadline>{item.label}</LittleSubHeadline>
                        </StructureItem>)}
                        <StructureItem className="d-flex align-items-center justify-content-center gap-2"
                            style={{ cursor: 'pointer', borderRadius: !isOpen ? "8px" : "" }}
                            onClick={() => navigate(`/settings/structure/${structure.entity}/add`, {
                                state: {title: "Загальна інформація", missingItems: []},
                            })}>
                            <img src={plusIcon} alt="plus-icon" data-type="plus-icon" />
                            <LittleSubHeadline className="accent-text">Додати поле</LittleSubHeadline>
                        </StructureItem>
                        {hiddenFields.map((item) =>
                            <StructureItem key={item.key} className="structure-item--disabled" onClick={() => navigate(`/settings/structure/${structure.entity}/update`, {
                                state: item,
                            })}>
                                <img src={item.icon} alt={item.key} />
                                <LittleSubHeadline>{item.label}</LittleSubHeadline>
                            </StructureItem>)}
                    </motion.div>
                </StructureItems>
                <StructureItems className="mt-2">
                    <StructureItem onClick={() => setIsOpenOther((v) => !v)}
                        style={{ cursor: 'pointer', borderRadius: !isOpenOther ? "8px" : "" }}>
                        {/* <img src={item.icon} alt={item.key} /> */}
                        <MediumText>Пов’язані записи</MediumText>
                        <img src={chevronIcon} alt="chevron-icon"
                            style={{
                                marginLeft: 'auto',
                                transform: isOpenOther ? 'rotate(0deg)' : 'rotate(-90deg)',
                                transition: 'transform 0.2s ease',
                            }}
                        />
                    </StructureItem>
                    <motion.div
                        initial={false}
                        className="structure-group"
                        animate={{
                            height: isOpenOther ? 'auto' : 0,
                            opacity: isOpenOther ? 1 : 0,
                        }}
                        transition={{
                            type: 'spring',
                            stiffness: 110,
                            damping: 22,
                        }}
                        style={{ overflow: 'hidden', scrollBehavior: 'smooth' }}
                    >{structure.fields.other.filter((f) => f.visible).map((item) =>
                        <StructureItem key={item.key} className="" onClick={() => navigate(`/settings/structure/${structure.entity}/update`, {
                            state: item,
                        })}>
                            <img src={item.icon} alt={item.key} />
                            <LittleSubHeadline>{item.label}</LittleSubHeadline>
                        </StructureItem>)}
                        {structure.fields.other.filter(x => !x.visible).length > 0 && <StructureItem className="d-flex align-items-center justify-content-center gap-2"
                            style={{ cursor: 'pointer', borderRadius: !isOpen ? "8px" : "" }}
                            onClick={() => navigate(`/settings/structure/${structure.entity}/add`, {
                                state: {title: "Пов’язані записи", missingItems: structure.fields.other.filter(x => !x.visible)},
                            })}>
                            <img src={plusIcon} alt="plus-icon" data-type="plus-icon" />
                            <LittleSubHeadline className="accent-text">Додати запис</LittleSubHeadline>
                        </StructureItem>}
                    </motion.div>
                </StructureItems>
            </StructureSection>
        </FixedBodyDiv>
    )
}